import { defaultTo } from 'lodash';
import { IModel, Model } from '.';

export interface IHospitalPrescriptionRefillStatusModel extends IModel {
  hospitalPrescriptionRefillStatusId: number;
  name: string;
  description: string;
}

export class HospitalPrescriptionRefillStatusModel
  extends Model
  implements IHospitalPrescriptionRefillStatusModel
{
  hospitalPrescriptionRefillStatusId: number;
  name: string;
  description: string;

  constructor(params?: Partial<IHospitalPrescriptionRefillStatusModel>) {
    super(params);
    this.hospitalPrescriptionRefillStatusId = defaultTo(
      params?.hospitalPrescriptionRefillStatusId,
      0,
    );
    this.name = defaultTo(params?.name, '');
    this.description = defaultTo(params?.description, '');
  }
}
